import api from '../utils/api';

const inventoryService = {
  listCategories: async () => {
    try {
      return await api.get('/api/inventory/categories');
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },
  createCategory: async (data) => {
    try {
      return await api.post('/api/inventory/categories', data);
    } catch (error) {
      console.error('Error creating category:', error);
      throw error;
    }
  },
  updateCategory: async (categoryId, data) => {
    try {
      return await api.put(`/api/inventory/categories/${categoryId}`, data);
    } catch (error) {
      console.error('Error updating category:', error);
      throw error;
    }
  },
  deleteCategory: async (categoryId) => {
    try {
      return await api.delete(`/api/inventory/categories/${categoryId}`);
    } catch (error) {
      console.error('Error deleting category:', error);
      throw error;
    }
  },

  listAssets: async () => {
    try {
      return await api.get('/api/inventory/assets');
    } catch (error) {
      console.error('Error fetching assets:', error);
      throw error;
    }
  },
  createAsset: async (data) => {
    try {
      return await api.post('/api/inventory/assets', data);
    } catch (error) {
      console.error('Error creating asset:', error);
      throw error;
    }
  },
  updateAsset: async (assetId, data) => {
    try {
      return await api.put(`/api/inventory/assets/${assetId}`, data);
    } catch (error) {
      console.error('Error updating asset:', error);
      throw error;
    }
  },
  deleteAsset: async (assetId) => {
    try {
      return await api.delete(`/api/inventory/assets/${assetId}`);
    } catch (error) {
      console.error('Error deleting asset:', error);
      throw error;
    }
  },

  listStockItems: async () => {
    try {
      return await api.get('/api/inventory/stock-items');
    } catch (error) {
      console.error('Error fetching stock items:', error);
      throw error;
    }
  },
  createStockItem: async (data) => {
    try {
      return await api.post('/api/inventory/stock-items', data);
    } catch (error) {
      console.error('Error creating stock item:', error);
      throw error;
    }
  },
  updateStockItem: async (itemId, data) => {
    try {
      return await api.put(`/api/inventory/stock-items/${itemId}`, data);
    } catch (error) {
      console.error('Error updating stock item:', error);
      throw error;
    }
  },
  deleteStockItem: async (itemId) => {
    try {
      return await api.delete(`/api/inventory/stock-items/${itemId}`);
    } catch (error) {
      console.error('Error deleting stock item:', error);
      throw error;
    }
  },
  issueStock: async (itemId, data) => {
    try {
      return await api.post(`/api/inventory/stock-items/${itemId}/issue`, data);
    } catch (error) {
      console.error('Error issuing stock:', error);
      throw error;
    }
  },
  listIssuances: async (stockItemId) => {
    try {
      return await api.get('/api/inventory/stock-issuances', { params: { stock_item_id: stockItemId } });
    } catch (error) {
      console.error('Error fetching stock issuances:', error);
      throw error;
    }
  },
  approveIssuance: async (itemId, issuanceId) => {
    try {
      return await api.post(`/api/inventory/stock-items/${itemId}/issuances/${issuanceId}/approve`);
    } catch (error) {
      console.error('Error approving issuance:', error);
      throw error;
    }
  },
  rejectIssuance: async (itemId, issuanceId, rejectionReason) => {
    try {
      return await api.post(`/api/inventory/stock-items/${itemId}/issuances/${issuanceId}/reject`, { rejection_reason: rejectionReason });
    } catch (error) {
      console.error('Error rejecting issuance:', error);
      throw error;
    }
  },

  listSuppliers: async () => api.get('/api/procurement/suppliers'),
  createSupplier: async (data) => api.post('/api/procurement/suppliers', data),
  updateSupplier: async (id, data) => api.put(`/api/procurement/suppliers/${id}`, data),
  listPurchaseOrders: async () => api.get('/api/procurement/purchase-orders'),
  createPurchaseOrder: async (data) => api.post('/api/procurement/purchase-orders', data),
  submitPurchaseOrder: async (id) => api.post(`/api/procurement/purchase-orders/${id}/submit`),
  approvePurchaseOrder: async (id) => api.post(`/api/procurement/purchase-orders/${id}/approve`),
  cancelPurchaseOrder: async (id) => api.post(`/api/procurement/purchase-orders/${id}/cancel`),
  receivePurchaseOrder: async (id, lines) => api.post(`/api/procurement/purchase-orders/${id}/receive`, { lines }),
  listRequisitions: async () => api.get('/api/procurement/requisitions'),
  createRequisition: async (data) => api.post('/api/procurement/requisitions', data),
  submitRequisition: async (id) => api.post(`/api/procurement/requisitions/${id}/submit`),
  approveRequisition: async (id) => api.post(`/api/procurement/requisitions/${id}/approve`),
  rejectRequisition: async (id, rejectionReason) => api.post(`/api/procurement/requisitions/${id}/reject`, { rejection_reason: rejectionReason }),
  convertRequisition: async (id, data) => api.post(`/api/procurement/requisitions/${id}/convert`, data),
  listGoodsReceivedNotes: async () => api.get('/api/procurement/goods-received-notes'),
  listStockReturns: async () => api.get('/api/procurement/returns'),
  createStockReturn: async (data) => api.post('/api/procurement/returns', data),
  approveStockReturn: async (id) => api.post(`/api/procurement/returns/${id}/approve`),
  rejectStockReturn: async (id) => api.post(`/api/procurement/returns/${id}/reject`),
  listReorderSuggestions: async () => api.get('/api/procurement/reorder-suggestions'),
  listStockTransfers: async () => api.get('/api/procurement/transfers'),
  createStockTransfer: async (data) => api.post('/api/procurement/transfers', data),
  approveStockTransfer: async (id) => api.post(`/api/procurement/transfers/${id}/approve`),
  rejectStockTransfer: async (id) => api.post(`/api/procurement/transfers/${id}/reject`),
  listSupplierInvoices: async () => api.get('/api/procurement/supplier-invoices'),
  createSupplierInvoice: async (data) => api.post('/api/procurement/supplier-invoices', data),
  paySupplierInvoice: async (id, data) => api.post(`/api/procurement/supplier-invoices/${id}/payments`, data),
  voidSupplierInvoice: async (id) => api.post(`/api/procurement/supplier-invoices/${id}/void`),
  listSupplierBalances: async () => api.get('/api/procurement/supplier-balances'),
};

export default inventoryService;
